module.exports = __webpack_public_path__ + "img/Lead icon.6134bd8d.svg";